import { render } from "./NewSupplier.vue?vue&type=template&id=355733cf"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__